/**
 * Module-scope plane instances.
 * Initialized at app boot and accessible to all components.
 */
import { SampleAudioPlane } from "./audio/SampleAudioPlane";
import { WebTextPlane } from "./text/WebTextPlane";
import { getBellsEnabled } from "./state/settingsState";

export const audioPlane = new SampleAudioPlane({ getBellsEnabled });
export const textPlane = new WebTextPlane();

// voicePlane requires a running RetreatManager — see main.tsx for construction
